import {
    ADD_PEDIDOS,
    UPDATE_PEDIDO,
    CLEAR_PEDIDOS,
    ADD_CAPACIDADES,
    SHOW_LOADING,
    HIDE_LOADING,
    SET_PVS,
    SET_PVS_PEDIDOS,
    SET_PV_ATUAL,
    SET_DIAS_UTEIS,
    SET_DIAS_UTEIS_ATUAL,
    SET_CURRENT_DATA_PV,
    CLEAR_CURRENT_DATA_PV,
    SET_CURRENT_FACCAO,
    SET_DIAS_SEMANA,
    SET_SOMATORIO_DIAS,
    SET_SOMATORIO_DIAS_TODAS,
    SET_DATA_TODOS,
    SET_PIOR_DATA,
    CLEAR_DATA_TODOS,
    SHOW_SUCCESS,
    SHOW_WARNING,
    SHOW_ERROR,
    SET_DATA_INDICE_QUALIDADE,
    ADD_SOMATORIO,
    CLEAR_SOMATORIO,
    SET_CLEAR_SOMATORIO_DIAS_TODAS,
    CLEAR_LOAD,
    ADD_LOAD,
    IS_HOME,
    IS_NOT_HOME,
    SET_VERSAO,
    SET_CALENDARIO,
    SET_FACTION_FILTERS,
} from './actionTypes';

export const showLoading = () => ({
    type: SHOW_LOADING,
});

export const hideLoading = () => ({
    type: HIDE_LOADING,
});

export const setCurrentDataPV = data => ({
    type: SET_CURRENT_DATA_PV,
    data,
});

export const setPvAtual = data => ({
    type: SET_PV_ATUAL,
    data,
});

export const clearCurrentDataPv = () => ({
    type: CLEAR_CURRENT_DATA_PV,
});

export const setPVs = pvs => ({
    type: SET_PVS,
    pvs,
});

export const setPVsPedidos = pvs => ({
    type: SET_PVS_PEDIDOS,
    pvs,
});

export const setDiasUteis = data => ({
    type: SET_DIAS_UTEIS,
    data,
});

export const setDiasUteisAtual = data => ({
    type: SET_DIAS_UTEIS_ATUAL,
    data,
});

export const addPedidos = pedidos => ({
    type: ADD_PEDIDOS,
    pedidos,
});

export const clearPedidos = () => ({
    type: CLEAR_PEDIDOS,
});

export const updatePedido = pedido => ({
    type: UPDATE_PEDIDO,
    pedido,
});

export const addCapacidades = capacidades => ({
    type: ADD_CAPACIDADES,
    capacidades,
});

export const setCurrentFaccao = faccao => ({
    type: SET_CURRENT_FACCAO,
    faccao,
});

export const setDiasSemana = data => ({
    type: SET_DIAS_SEMANA,
    data,
});

export const setSomatorioDias = data => ({
    type: SET_SOMATORIO_DIAS,
    data,
});

export const setSomatorioDiasTodas = data => ({
    type: SET_SOMATORIO_DIAS_TODAS,
    data,
});

export const setDataTodos = data => ({
    type: SET_DATA_TODOS,
    data,
});

export const setPiorData = data => ({
    type: SET_PIOR_DATA,
    data,
});

export const clearDataTodos = () => ({
    type: CLEAR_DATA_TODOS,
});

export const showSuccess = payload => ({
    type: SHOW_SUCCESS,
    payload,
});

export const showWarning = payload => ({
    type: SHOW_WARNING,
    payload,
});

export const showError = payload => ({
    type: SHOW_ERROR,
    payload,
});

export const setDataIndiceQualidade = payload => ({
    type: SET_DATA_INDICE_QUALIDADE,
    payload,
});

export const addSomatorio = somatorio => ({
    type: ADD_SOMATORIO,
    somatorio,
});

export const clearSomatorio = () => ({
    type: CLEAR_SOMATORIO,
});

export const clearSomatorioTodas = () => ({
    type: SET_CLEAR_SOMATORIO_DIAS_TODAS,
});

export const addLoad = data => ({
    type: ADD_LOAD,
    data,
});

export const clearLoad = _ => ({
    type: CLEAR_LOAD,
});

export const setIsHome = _ => ({
    type: IS_HOME,
});
export const setIsNotHome = _ => ({
    type: IS_NOT_HOME,
});
export const setVersao = payload => ({
    type: SET_VERSAO,
    payload,
});

export const setCalendario = payload => ({
    type: SET_CALENDARIO,
    payload,
});

export const setFactionFilters = data => ({
    type: SET_FACTION_FILTERS,
    data,
});
